import React, {useState, useEffect} from 'react';
import {calendar} from '../../assets/imageDir';
import Moment from 'moment';
import {useDispatch, useSelector} from 'react-redux';
import {
  changeTrainingTimePage,
  changeServicePage,
  clearTimeSlots,
  setSessionTrainingDate,
  setSessionTrainingTime,
  setSelectedFamilyMemberSession,
} from '../../redux/actions/index';
import {BASE_URL_WEB, IMAGE_URL} from '../../utility/constants';
import {
  AxiosHelperPortal,
  dateFormatter,
  getInitials,
  tConvert,
} from '../../utility/helperFunctions';
import {AppLoader} from '..';
import BookingSteps from '../BookingSteps';
import FamilyMemberListSession from '../FamilyMemberListSession/FamilyMemberListSession';
import {useHistory} from 'react-router-dom';

const BookingPage3 = () => {
  const [loading, setLoading] = useState(true);
  const [availableTimes, setAvailableTimes] = useState([]);
  const history = useHistory();
  const [isShowTimeSlot, setShowTimeSlot] = useState({
    show: true,
    message: '',
  });
  const dispatch = useDispatch();
  const bookingDetails = useSelector(state => state.booking);
  const trainingTime = bookingDetails?.trainingTime;
  const authDetails = useSelector(state => state.auth);
  const [showRegistrationSuccess, setShowRegistrationSuccess] = useState(false);
  const selectedTrainer =
    authDetails.companyData?.trainers?.items?.[bookingDetails?.trainer?.id] ||
    bookingDetails?.trainer;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const registrationComplete = params.get('registration') === 'complete';
    if (!registrationComplete) return;
    setShowRegistrationSuccess(true);
    params.delete('registration');
  }, []);

  useEffect(() => {
    const companyHasMRF = authDetails?.companyData?.mrf === true;
    const memberMRFCompleted = authDetails?.companyData?.member?.mrf === false;
    if (companyHasMRF && memberMRFCompleted) {
      history.push(`/member-questionnaire/${authDetails?.companyData?.id}`);
    }
  }, [
    authDetails?.companyData?.id,
    authDetails?.companyData?.member?.mrf,
    authDetails?.companyData?.mrf,
    history,
  ]);

  useEffect(() => {
    let cancelled = false;
    const selectedDate = trainingTime?.date;
    const presentDate = Moment();
    const trainingDate = Moment(selectedDate);
    const configuredMaxDays = parseInt(authDetails?.companyData?.booking_max_days ?? 30, 10);
    const bookingMaxDays = Number.isNaN(configuredMaxDays) ? 30 : configuredMaxDays;
    const timeLimit = Moment().add(bookingMaxDays, 'days');

    const hideTimeSlots = message => {
      setAvailableTimes([]);
      setLoading(false);
      setShowTimeSlot({show: false, message});
    };

    if (!selectedDate || !trainingDate.isValid()) {
      hideTimeSlots('Please select a valid date.');
      return () => {
        cancelled = true;
      };
    }

    if (trainingDate.isBefore(presentDate, 'date')) {
      hideTimeSlots('Please add a future date or time.');
      return () => {
        cancelled = true;
      };
    }

    if (trainingDate.isAfter(timeLimit, 'date')) {
      hideTimeSlots(`Sorry! Please select date from now to ${bookingMaxDays} days.`);
      return () => {
        cancelled = true;
      };
    }

    if (!selectedTrainer?.id) {
      hideTimeSlots(
        'We could not find the selected coach. Please go back and select a coach again.'
      );
      return () => {
        cancelled = true;
      };
    }

    setLoading(true);
    setAvailableTimes([]);
    setShowTimeSlot({show: true, message: ''});
    const url = `${BASE_URL_WEB}trainer-availability?branchTrainerTableId=${
      selectedTrainer.id
    }&date=${selectedDate}&duration=${bookingDetails.service?.duration}&extraTime=${
      bookingDetails.service?.extraTime ?? 0
    }`;
    console.log(url);
    AxiosHelperPortal(url, 'get', authDetails?.authDetails?.username, 'member')
      .then(response => {
        if (cancelled) return;
        const data = response.data;
        console.log(response);
        setAvailableTimes(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(function (error) {
        if (cancelled) return;
        console.log(error);
        hideTimeSlots('Unable to load available times. Please try another date or try again.');
      });

    return () => {
      cancelled = true;
    };
  }, [
    authDetails?.authDetails?.username,
    authDetails?.companyData?.booking_max_days,
    bookingDetails?.service?.duration,
    bookingDetails?.service?.extraTime,
    selectedTrainer?.id,
    trainingTime?.date,
  ]);

  const _dateAndTimeValidation = () => {
    dispatch(changeTrainingTimePage());
  };

  const _handleTimeChange = e => {
    dispatch(setSessionTrainingTime(e.target.value));
  };

  const _handleFmChange = fmId => {
    dispatch(setSelectedFamilyMemberSession(fmId));
  };
  console.log('isShowTimeSlot', isShowTimeSlot, availableTimes);
  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container">
            <div className="container">
              {showRegistrationSuccess && (
                <div className="row">
                  <div className="col-12">
                    <div
                      className="alert alert-success d-flex justify-content-between align-items-start"
                      role="alert"
                    >
                      <div>
                        Congratulations on completing the registration process! You can now book
                        services and manage your account. You can find{' '}
                        <a
                          href="https://coachfirst.tawk.help/article/the-client-guide-to-coachfirst"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          The Client Guide to CoachFirst
                        </a>{' '}
                        in the menu under your name.
                      </div>
                      <button
                        type="button"
                        className="btn btn-link p-0 ms-3"
                        onClick={() => setShowRegistrationSuccess(false)}
                        aria-label="Dismiss registration success message"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className="_cardTop-hdr mb-4 text-center page-title">
                <h2 className="_text-dark">Select Date & Time</h2>
              </div>

              <BookingSteps step={3} />
              <div className="_sessionBookingPage mt-2">
                <div className="container">
                  <div className="row align-items-center">
                    <div className="booking_page">
                      <div className="_bookingTable-outter _list-outter">
                        <>
                          <div className="_clientProDiv">
                            <span className="_proPic">
                              {selectedTrainer?.imageUrl ? (
                                <img src={IMAGE_URL + selectedTrainer?.imageUrl} alt="" />
                              ) : (
                                <span className="avName">
                                  <span className="proName">
                                    {getInitials(
                                      selectedTrainer?.firstName,
                                      selectedTrainer?.lastName
                                    )}
                                  </span>
                                </span>
                              )}
                            </span>
                            <div className="_clCont">
                              <p className="_name _title-2">{selectedTrainer?.trainerName}</p>
                              <p className="_info">{selectedTrainer?.email}</p>
                            </div>
                          </div>
                          <div className="_bookingDetails">
                            <p>
                              <span className="text-dark">
                                {bookingDetails?.service?.serviceName}
                              </span>
                            </p>
                            <div className="row mb-3">
                              <p className="col-md-12 col-form-label pb-0 pt-0 mb-0">
                                <strong className="text-dark">Select Date : </strong>
                              </p>
                              <div className="col-md-4">
                                <input
                                  className="form-control"
                                  type="date"
                                  value={dateFormatter(trainingTime?.date ?? Moment(), 1)}
                                  id="example-date-input"
                                  onChange={e => dispatch(setSessionTrainingDate(e.target.value))}
                                />
                              </div>
                            </div>
                            {isShowTimeSlot.show ? (
                              <>
                                <p>
                                  <strong className="text-dark">Select Time : </strong>
                                </p>
                                <div className="_timeListDiv">
                                  <ul className="_timeList">
                                    {loading ? (
                                      <AppLoader height={50} width={50} />
                                    ) : (
                                      <>
                                        {availableTimes?.map((item, index) => (
                                          <li key={index}>
                                            <label className="_t-label">
                                              <input
                                                type="radio"
                                                name="time"
                                                value={item}
                                                checked={item === trainingTime?.time}
                                                onChange={_handleTimeChange}
                                              />
                                              <span className="_timeSpan">{tConvert(item)}</span>
                                            </label>
                                          </li>
                                        ))}
                                        {availableTimes?.length === 0 && (
                                          <span style={{color: 'red'}}>
                                            No times available on this date.
                                          </span>
                                        )}
                                      </>
                                    )}

                                    {/* <li
                                onClick={() => {
                                  setShowTimeField(!showTimeField);
                                  setTime({ ...time, custom: true });
                                }}
                              >
                                <label className="_t-label">
                                  <span
                                    className={
                                      showTimeField || time.custom
                                        ? "_timeSpan _selected"
                                        : "_timeSpan"
                                    }
                                    id="cT-btn"
                                  >
                                    Custom Time
                                  </span>
                                </label>
                              </li> */}
                                  </ul>
                                  {/* <div
                                className={
                                  showTimeField ? "_ctimeDiv show" : "_ctimeDiv"
                                }
                              >
                                <input
                                  type="time"
                                  className="form-control"
                                  onChange={(e) => {
                                    setTime({
                                      time: e.target.value,
                                    });
                                    console.log(e.target.value);
                                    // _handleTimeChange(e.target.value);
                                  }}
                                />
                              </div> */}
                                  <div className="_finalDate">
                                    <span className="_icon">
                                      <img src={calendar} alt="" />
                                    </span>
                                    <p>{dateFormatter(trainingTime?.date ?? Moment(), 2)}</p>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <span style={{color: 'red'}}> {isShowTimeSlot.message}</span>
                            )}
                          </div>
                        </>
                        <FamilyMemberListSession _handleFmChange={_handleFmChange} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="_btnGrp text-center py-4">
            <button
              className="btn btn-outline-danger px-5"
              onClick={() => {
                dispatch(changeServicePage(bookingDetails.service));
                dispatch(clearTimeSlots());
              }}
            >
              Back
            </button>
            <button
              className="btn btn-primary px-5"
              onClick={_dateAndTimeValidation}
              disabled={!isShowTimeSlot.show || !trainingTime?.date || !trainingTime?.time}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingPage3;
